<template>
  <div class="columns is-centered">
    <section class="section">
      <div class="box">
        <div class="tabs is-toggle is-fullwidth" id="tabs">
          <ul>
            <li :class="[ activeTab === 'accountDetails' ? 'is-active' : '']">
              <a @click="activeTab='accountDetails'">
                <span>Account Details</span>
              </a>
            </li>
            <li :class="[ activeTab === 'subscriptionManagement' ? 'is-active' : '']">
              <a @click="activeTab='subscriptionManagement'">
                <span>Subscription Management</span>
              </a>
            </li>
            <li :class="[ activeTab === 'changePassword' ? 'is-active' : '']">
              <a @click="activeTab='changePassword'">
                <span>Change Password</span>
              </a>
            </li>
          </ul>
        </div>
        <div id="tab-content">
          <form
            class="changepassword"
            v-if="activeTab==='changePassword'"
            @submit.prevent="changePassword"
          >
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Old Password</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input required autofocus class="input" type="password" v-model="oldPassword" />
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">New Password</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <input required autofocus class="input" type="password" v-model="newPassword" />
                </div>
              </div>
            </div>
            <div class="field">
              <p class="help is-danger is-normal" v-if="error">{{statusMessage}}</p>
              <p class="help is-success is-normal" v-if="!error">{{statusMessage}}</p>
            </div>
            <div class="field">
              <div class="control">
                <button class="button is-block is-fullwidth is-link">Submit</button>
              </div>
            </div>
          </form>

          <div class="content" v-if="activeTab==='accountDetails'">
            <div>
              <p class="label">Full Name: {{account.fullName}}</p>
              <p class="label">Email Address: {{account.email}}</p>
              <p class="label">Company: {{account.companyName}}</p>
              <p class="label">Subscription Type: {{account.subscriptionType}}</p>
              <p class="label">Licensed Calendar Users: {{account.subscribedCalendarUsers}}</p>
              <p
                class="label"
                v-if="account.subscriptionType.toLowerCase()!='trial'"
              >Account Renews On: {{accountExpiry}}</p>
            </div>
          </div>

          <div class="content" v-if="activeTab==='subscriptionManagement'">
            <p v-if="account.subscriptionType.toLowerCase() != 'trial'">
              <a @click="addCalendarUsers">Add Calendar Users</a>
              <AddCalendarUsers :accountSubscriptionType="account.subscriptionType" />
            </p>
            <p v-if="account.subscriptionType.toLowerCase() ==='trial'">
              <a @click="upgradeAccount">Upgrade Account</a>
            </p>
            <p>
              <a @click="cancelAccount">Cancel Account</a>
              <CancelAccount />
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AddCalendarUsers from "@/components/AddCalendarUsers.vue";
import CancelAccount from "@/components/CancelAccount.vue";

import EventBus from "../event-bus";
import date from "date-and-time";

export default {
  name: "UserPreferences",
  props: {
    account: Object,
    default: "",
    required: true
  },
  components: {
    AddCalendarUsers,
    CancelAccount
  },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      activeTab: "accountDetails",
      error: false,
      statusMessage: ""
    };
  },
  computed: {
    /*
       /account endpoint returns account_created_on which is passed down as a property from the parent component (MileLogix)
       Subscriptions can renew on a monthly or annual basis. This computed property will display the correct renewal date based
       on the subscription type and day of the month account_created_on was set to.
    */
    accountExpiry: function() {
      let currentDate = new Date();
      let createdDate = date.parse(this.account.createdOn, "MM/DD/YYYY");
      let renewalDayOfMonth = createdDate.getDate();
      let renewalMonth = createdDate.getMonth();

      currentDate.setDate(renewalDayOfMonth);
      switch (this.account.subscriptionType.toLowerCase()) {
        case "annual":
          currentDate.setMonth(renewalMonth);
          currentDate = date.addMonths(currentDate, 12);
          break;

        case "monthly":
          currentDate = date.addMonths(currentDate, 1);
          break;
      }
      return date.format(currentDate, "MMMM D YYYY");
    }
  },
  methods: {
    cancelAccount: function() {
      EventBus.$emit("displayCancelAccount", true);
    },

    addCalendarUsers: function() {
      EventBus.$emit("displayAddCalendarUsers", true);
    },
    upgradeAccount: function() {
      EventBus.$emit("displayUpgradeAccount", true);
    },
    changePassword: function() {
      let data = {
        oldpass: this.oldPassword,
        newpass: this.newPassword
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "/resetsecret", data)
        .then(() => {
          this.statusMessage = "Password successfully changed";
          this.error = false;
        })
        .catch(httpError => {
          if (httpError.response) {
            if (httpError.response.status == 401) {
              localStorage.removeItem("token");
              this.$router.push("/");
            }

            if (httpError.response.status == 400) {
              switch (httpError.response.data.error) {
                case "invalid password":
                  this.error = true;
                  this.statusMessage = "Invalid Password";
                  break;
                default:
                  this.error = true;
                  this.statusMessage =
                    "Error changing password. Please try again later";
              }
            }
          }
        });
    }
  }
};
</script>
